module.exports = __webpack_public_path__ + "static/media/photo-13.3234aa6f.avif";